// Use CRUD naming to align with RESTful API (as opposed to GraphQL or RPC)
import { type MenuId } from '../../../models';

interface Response {
  configData: string;
}

const baseUrl = process.env.REACT_APP_NAV_API ?? '';

export async function readShortcuts(gatewayApiUrl: string): Promise<MenuId[]> {
  const response = await fetch(
    `${baseUrl}${gatewayApiUrl}/api/idw/config/HOMEPAGE_QUICKLINKS`
  );
  const data = (await response.json()) as Response;

  if (data.configData === '') {
    return [];
  }

  const obj = JSON.parse(data.configData) as object;

  return Object.keys(obj);
}
